export default {
    "Dashboard": "看板",
    "cache": "缓存",
    "Tile Cache": "瓦片缓存",
    "List": "列表",
}
